/* global Y, $ */
export function initMap() {
	const map_data = [{
			id: 'major_org',
			url: '/wp-content/major_org.json'
		},
		{
			id: 'nbrp',
			url: '/wp-content/nbrp.json'
		},
		{
			id: 'anrrc',
			url: '/wp-content/anrrc.json'
		},
		{
			id: 'ammra',
			url: '/wp-content/ammra.json'
		}
	]

	let maker_major_org = []
	let maker_nbrp = []
	let maker_anrrc = []
	let maker_ammra = []

	map_data.forEach(data => {
		fetch(document.baseURI + data.url + '?date=' + new Date().getTime())
			.then(res => {
				return res.json()
			})
			.then(json => {
				switch (data.id) {
					case 'major_org':
						maker_major_org = json.maker
						CreateMap("MAJOR", 20.340812, -156.012564, 3, maker_major_org);
					case 'nbrp':
						maker_nbrp = json.maker
					case 'anrrc':
						maker_anrrc = json.maker
					case 'ammra':
						maker_ammra = json.maker
				}
			})
	})

	$('.maptab').on('click', function () {
		$('#map_list').empty()
		$('.maptab').removeClass('on')
		$('.ymapicon').removeClass('on')
		$(this).addClass('on')
		var map_type = this.textContent
		switch (map_type) {
			case '世界の主要機関':
				CreateMap("MAJOR", 20.340812, -156.012564, 3, maker_major_org);
				break;
			case 'NBRP':
				CreateMap("NBRP", 34.5552566, 136.431481, 7.5, maker_nbrp);
				$('.ymapicon.-nbrp').addClass('on')
				break;
			case 'ANRRC':
				CreateMap("ANRRC", 31.8765454, 118.1865454, 5.5, maker_anrrc);
				$('.ymapicon.-anrrc').addClass('on')
				break;
			case 'AMMRA':
				CreateMap("AMMRA", 31.8765454, 118.1865454, 5.5, maker_ammra);
				$('.ymapicon.-ammra').addClass('on')
				break;
		}
	});
}

function CreateMap(layer_name, d_lat, d_lng, d_zoom, makerList) {
	var ymap = new Y.Map("map", {
		configure: {
			doubleClickZoom: true,
			scrollWheelZoom: true
		}
	});
	// 縮尺バー(縦)表示
	//  var control = new Y.SliderZoomControlVertical(); 
	var control = new Y.ZoomControl();
	ymap.addControl(control);

	// レイヤーを作成
	var map_orig = new Y.StyleMapLayer("standard");
	// レイヤーセットを作成
	var layerset = new Y.LayerSet(layer_name, [map_orig], {
		"maxZoom": 10,
		"minZoom": 3
	});
	// Mapオブジェクトにレイヤーセットを追加
	ymap.addLayerSet("map_orig", layerset);
	// 地図を描画
	ymap.drawMap(new Y.LatLng(d_lat, d_lng), d_zoom, Y.LayerSetId.NORMAL);
	// レイヤーを表示
	ymap.setLayerSet("map_orig");

	// リストをセット
	var number = 1;
	var list = "";

	// 地図プロット リスト表示処理
	for (var idx in makerList) {
		var markerData = makerList[idx]
		var marker = new Y.Marker(new Y.LatLng(markerData.lat, markerData.lng), markerData.s_title);
		if (markerData.banner.length == 0) {
			marker.bindInfoWindow("<div class= 'marker_info'><a href=" + markerData.link + "  target=_new " + "onclick=ga('send','event','map_" + layer_name + "','click','" + markerData.c_title + "','1'); >" + markerData.title + "</a><br>" + markerData.info + "<br></div>");
		} else {
			marker.bindInfoWindow("<div class= 'marker_info'><a href=" + markerData.link + "  target=_new  " + "onclick=ga('send','event','map_" + layer_name + "','click','" + markerData.c_title + "','1'); >" + markerData.title + "</a><br>" + markerData.info + "<br><img src=" + markerData.banner + "></div>");
		}

		ymap.addFeature(marker);
		var title = markerData.s_title;
		createMarkerButton(marker, title);
		number++;
	}
	// toggleMap()
}

// リストクリックで、地図に詳細情報が表示される
function createMarkerButton(marker, title) {
	var container = document.getElementById("map_list");
	var item = document.createElement("li");
	item.innerHTML = title;
	container.appendChild(item);
	Y.Event.addListener(item, "click", function () {
		Y.Event.trigger(marker, 'click')
	});
}